<script>
import CatalogPage from '../../components/pages/CatalogPage'
export default CatalogPage
</script>
